import { createEnvConfig } from '@talos/kyoko';

// Runtime-configurable environment variables (injectable at Docker startup)
export interface EnvConfig {
  readonly VITE_SESSION_COOKIE: string;
  readonly VITE_AVA_ENV: 'local' | 'develop' | 'staging' | 'uat' | 'alpha' | 'sandbox' | 'prod' | 'test';
  readonly VITE_API_ENDPOINT: string;
  readonly VITE_AUTH_LOGIN_URL: string;
  readonly VITE_AUTH_LOGOUT_URL: string;
  readonly VITE_AUTH_ACCESS_TOKEN_URL: string;
  readonly VITE_AUTH_EXCHANGE_TOKEN_URL: string;
  readonly VITE_AUTH_SILENT_LOGIN_URL?: string;
  readonly VITE_WS_ENDPOINT: string;
  readonly VITE_DATADOG_CLIENT_TOKEN: string;
  readonly VITE_DATADOG_APP_ID: string;
  readonly VITE_DATADOG_PROXY_URL?: string;
}

export const envConfig = createEnvConfig<EnvConfig>(import.meta.env);
